
<lib-content
	class="swipe-enabled"
	*rxLet="page$ let page"
	[page]="page"
>
	{{ page.body }}
</lib-content>
